import { Typography, Popconfirm, Button } from "antd";
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';




export const dataSource = [
    {
      key: '1',
      code: '10000',
      name: 'Current Asset',
      type: 'Current Assets',
    },
    {
      key: '2',
      code: '10002',
      name: 'John',
      type: 'Current Assets',
      editable: true,
    },
  ];
  
export const entriesColumns = [
  // {
  //   title: 'Date',
  //   dataIndex: 'date',
  //   key: 'date',
  //   className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
  //   editable: true,
  //   width: '20%'
  // },
    {
      title: 'Account',
      dataIndex: 'account_id',
      key: 'account',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
      width: '20%'
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
    },
    {
      title: 'Analytics',
      dataIndex: 'analytics',
      key: 'analytics',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
    },
    {
      title: 'Taxes',
      dataIndex: 'taxes',
      key: 'taxes',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
      width: '15%'
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
      editable: true,
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 100,
      className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
      // render: (_, record) => {
      //   const editable = record.status;
      //   return editable ? (
      //     <span>
      //       <Typography.Link
      //         onClick={() => {}}
      //         style={{
      //           marginRight: 8,
      //         }}
      //       >
      //         Save
      //       </Typography.Link>
      //       <Popconfirm title="Sure to cancel?">
      //         <a>Cancel</a>
      //       </Popconfirm>
      //     </span>
      //   ) : (
      //     <Typography.Link disabled={editable !== ''} >
      //       Edit
      //     </Typography.Link>
      //   );
      // },
    },
  ];


export const paymentColumns = [
  {
    title: 'Payment Method',
    dataIndex: 'method',
    key: 'method',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '30%'
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '30%'
  },{
    title: 'OutStanding Payment Account',
    dataIndex: 'outstanding_account_id',
    key: 'outstanding_account_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },  
  {
    title: ''
  }
]

export const paymentReceiptColumn = [
  {
    title: 'Payment Method',
    dataIndex: 'method',
    key: 'method',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '30%'
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '30%'
  },{
    title: 'OutStanding Receipt Account',
    dataIndex: 'outstanding_account_id',
    key: 'outstanding_account_id',
    className: 'whitespace-nowrap font-medium text-[#04949b] dark:text-white',
    editable: true,
    width: '20%'
  },  
  {
    title: ''
  }
]

export const ActionColumn = (_, record, isEditing, save, edit, cancel, remove) => {
  const editable = isEditing(record);
  return editable ? (
    <span>
      <Button
        type="primary"
        icon={<SaveOutlined />}
        onClick={() => save(record)}
        style={{ marginRight: 8 }}
      />
      {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}> */}
        <Button icon={<CloseOutlined />} onClick={cancel} />
      {/* </Popconfirm> */}
    </span>
  ) : (
    <span>
      <Button
        type="primary"
        onClick={() => edit(record)}
        icon={<EditOutlined />}
        className="mr-3"
      />
      <Button
        type="primary"
        danger
        onClick={() => remove(record)}
        icon={<DeleteOutlined />}
      />
    </span>
    
  );
}

